class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        const self = this;
        this.attachmentsArr = [];
        if (this.hasAttribute('data-add-ones-remove')) {
            this.addEventListener('click', (event) => {
                event.preventDefault();
                self.attachmentsArr = this.getAttribute('data-add-ones-remove').split('|');
                this.removeAddOnsItems();
            })
        } else {
            this.addEventListener('click', (event) => {
                event.preventDefault();
                if(this.dataset.hidden > 0) {
                    this.closest('cart-items').updateQuantity(this.dataset.index, this.dataset.hidden, '', 0);
                } else {
                    this.closest('cart-items').updateQuantity(this.dataset.index, 0, '', 0);
                }
            });
        }
    }

    removeAddOnsItems() {
        const self = this;
        self.closest('cart-items').enableLoading(1);
        let body = JSON.stringify({
            line: this.dataset.index,
            quantity: 0,
            sections: self.closest('cart-items').getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });
        let cartState;
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                cartState = JSON.parse(state);

                function removeAttachments() {
                    if (self.attachmentsArr.length) {
                        const attachment = self.attachmentsArr.shift();
                        const attachmentItem = attachment.split(':');
                        const productHref = attachmentItem[1];
                        const productId = attachmentItem[3];
                        const productQty = Number(attachmentItem[2]);
                        const cartItem = cartState.items.find(function (item) {
                            return (item.handle === productHref && item.id === +productId) && !item.properties['_add_ons']
                        });
                        if(cartItem) {
                            body = JSON.stringify({
                                id: cartItem.id.toString(),
                                quantity: cartItem.quantity - productQty,
                                sections: self.closest('cart-items').getSectionsToRender().map((section) => section.section),
                                sections_url: window.location.pathname
                            });
                            fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
                                .then((response) => {
                                    return response.text();
                                })
                                .then((state) => {
                                    cartState = JSON.parse(state);
                                    removeAttachments();
                                })
                                .catch((e) => {
                                    console.log(e)
                                    document.getElementById('cart-errors').textContent = window.cartStrings.error;
                                    // this.disableLoading();
                                });
                        } else {
                            self.renderCartItems(cartState)
                        }
                    } else {
                        self.renderCartItems(cartState);
                    }
                }

                removeAttachments();
            }).catch(() => {
            document.getElementById('cart-errors').textContent = window.cartStrings.error;
            // this.disableLoading();
        });
    }

    renderCartItems(parsedState) {
        if (location.href.includes('samples')) {
            document.dispatchEvent(
                new CustomEvent("qty.refresh", {
                    detail: parsedState.items, bubbles: true, cancelable: true, composed: false
                })
            );
        }
        this.closest('cart-items').renderContents(parsedState);
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.hidden)
  }

  getSectionsToRender() {
    let section = document.getElementById('main-cart-footer') ? document.getElementById('main-cart-footer').dataset.id : ''
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      /*
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },

      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      */
      {
        id: 'main-cart-footer',
        section: section,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, qty, name, hidden) {
    this.enableLoading(line);
    const quantity = (Number(qty) + Number(hidden)).toString();
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
          if(location.href.includes('samples')) {
              const parsedState = JSON.parse(state);
              document.dispatchEvent(
                  new CustomEvent("qty.refresh", {detail: parsedState.items, bubbles: true, cancelable: true, composed: false
                  })
              );
          }
        this.renderContents(JSON.parse(state));

        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        // this.disableLoading();
      }).catch(() => {
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        // this.disableLoading();
      });
  }

    renderContents(parsedState) {
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
            if(document.getElementById(section.id)){
                const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                if (this.closest('cart-notification')) {
                  let scrTop = document.querySelector('.s-cart-notification__body-in.scroll-content')
                      ? document.querySelector('.s-cart-notification__body-in.scroll-content').scrollTop : 0;
                  document.getElementById('s-cart-notification__pane').innerHTML = this.getSectionInnerHTML(parsedState.sections['s-cart-notification'], '.s-cart-notification__pane');
                  if (scrTop > 0) {
                      document.querySelector('.s-cart-notification__body-in').scrollTop = scrTop;
                  }
                  document.querySelector('#cart-icon-bubble .cart-count-bubble').innerHTML = parsedState.item_count;
                  $('#s-cart-notification__body [data-v-scrollbar]').scrollbar().scrollTop(scrTop);
                  $('[data-toggle="tooltip"]').tooltip();
                } else {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                    const itemsCount = this.getSectionInnerHTML(parsedState.sections[section.section], '.s-cart-items__qty span');
                    if (itemsCount) {
                        document.querySelector('.s-cart-items__qty span').innerHTML = itemsCount;
                        document.querySelector('.s-header__button .cart-count-bubble').innerHTML = itemsCount;
                        if (document.querySelector('.s-header__button .cart-count-bubble').innerHTML == '0') {
                            document.querySelector('.s-header__button .cart-count-bubble').remove();
                        }
                    }
                }
            }
            if (document.querySelector('.c-ref-product')) {
                $('[data-toggle="ref-product"]').click(function (e) {
                    e.preventDefault();
                    var $tooltip = $(this).find(".c-ref-product__title__info");
                    if (e.target === $tooltip[0]) return false;
                    $(this).closest('.c-ref-product').toggleClass('is-open').find('.c-ref-product__body').stop().slideToggle();
                });
                $('[data-color]').variantColorProduct();
                changeRefQty();
            }
        }));

        // this.updateLiveRegions(line, parsedState.item_count);
    }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const element = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);

    return element ? element.innerHTML : null;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
